<template>
  <div v-if="loading" class="container pt-2">
    Loading..
  </div>
  <div v-else class="container pt-2">
    <div class="row">
      <label class="form-label">Component</label>
      <select v-model="selectedDevComponent" class="form-control">
        <option value="">
          Select a dev component
        </option>
        <option
          v-for="devComponentName in devComponentNames" :key="devComponentName"
          :value="devComponentName"
        >
          {{ devComponentName }}
        </option>
      </select>
    </div>
    <div v-if="selectedDevComponent" class="row mt-2">
      <label class="form-label">Theme</label>
      <select v-model="selectedTheme" class="form-control">
        <option value="grey">
          Grey
        </option>
        <option value="blue">
          Blue
        </option>
        <option value="white">
          White
        </option>
      </select>
    </div>
    <div :class="`component-theme-${selectedTheme}`" class="row mt-2 component-container">
      <component :is="selectedDevComponent" v-if="selectedDevComponent" :theme="selectedTheme" />
      <div v-else>
        Select a Dev component in the dropdown above
      </div>
    </div>
  </div>
</template>

<script>
import { useSurveyStore } from '@/store';
import AnimatingNumberDev from '@/components/AnimatingNumber/AnimatingNumberDev.vue';
import AnimatingProgressBarDev from '@/components/AnimatingProgressBar/AnimatingProgressBarDev.vue';
import InputBarPillDev from '@/components/Inputs/InputBarPill/InputBarPillDev.vue';
import InputRadialSliderDev from '@/components/Inputs/InputRadialSlider/InputRadialSliderDev.vue';
import InputMultipleChoiceDev
  from '@/components/Inputs/InputMultipleChoice/InputMultipleChoiceDev.vue';
import InputMultipleAnswersDev
  from '@/components/Inputs/InputMultipleAnswers/InputMultipleAnswersDev.vue';
import InputButtonDev from '@/components/Inputs/common/InputButton/InputButtonDev.vue';
import InputDiagnosisDev from '@/components/Inputs/InputDiagnosis/InputDiagnosisDev.vue';
import InputTreatmentDev from '@/components/Inputs/InputTreatment/InputTreatmentDev.vue';
import InputPriorityDev from '@/components/Inputs/InputPriority/InputPriorityDev.vue';
import MarkdownTextDev from '@/components/common/MarkdownTextDev.vue';
import SummaryReportDev from '@/components/Report/SummaryReportDev.vue';
import FullReportDev from '@/components/Report/FullReportDev.vue';

import { BACKGROUND_GREY } from '@/enum/Background';
import DevPdfDownloader from '@/components/DevComponent/DevPdfDownloader';
import InputFreetextDev from '@/components/Inputs/InputFreetext/InputFreetextDev';
import ErrorThrowerDev from '@/components/common/ErrorThrowerDev';
import SurveyTableDev from '@/components/DevComponent/SurveyTableDev';

const devComponents = {
  AnimatingNumberDev,
  AnimatingProgressBarDev,
  InputBarPillDev,
  InputRadialSliderDev,
  InputMultipleChoiceDev,
  InputMultipleAnswersDev,
  InputButtonDev,
  InputDiagnosisDev,
  InputTreatmentDev,
  InputPriorityDev,
  InputFreetextDev,
  MarkdownTextDev,
  SummaryReportDev,
  FullReportDev,
  DevPdfDownloader,
  ErrorThrowerDev,
  SurveyTableDev,
};

export default {
  name: 'DevView',
  components: devComponents,
  data() {
    return {
      devComponentNames: Object.keys(devComponents),
      selectedDevComponent: '',
      selectedTheme: 'grey',
      loading: true,
    };
  },
  computed: {
    currentDevComponent() {
      return this.$router.currentRoute?.value?.params?.component;
    },
  },
  watch: {
    currentDevComponent() {
      if (this.currentDevComponent === this.selectedDevComponent) {
        return;
      }

      this.selectedDevComponent = this.currentDevComponent || '';
    },
    selectedDevComponent() {
      if (this.currentDevComponent === this.selectedDevComponent) {
        return;
      }

      console.log('Push router', `/dev/${this.selectedDevComponent}`);
      this.$router.push(`/dev/${this.selectedDevComponent}`);
    },
  },
  mounted() {
    useSurveyStore().setBackground(BACKGROUND_GREY);

    this.selectedDevComponent = this.currentDevComponent || '';

    this.loading = true;

    this.$apiClient.misc.getGameData().then((gameData) => {
      useSurveyStore().setTreatmentCategories(gameData.treatmentCategories);
      useSurveyStore().setDiagnosisCategories(gameData.diagnosisCategories);

      this.$apiClient.survey.getSurvey('main').then((surveyData) => {
        useSurveyStore().setQuestionGroups(surveyData.questionGroups);

        this.loading = false;
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.component-container {
  border: 1px solid #333333;
  padding: 10px;

  &.component-theme-grey {
    background: #EDF1F4;
  }

  &.component-theme-blue {
    background: #45A4CD;
  }

  &.component-theme-white {
    background: #F8F8F8;
  }
}
</style>
